
const WhatsAppButton = () => {
  const handleClick = () => {
    window.open('https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-gold hover:bg-gold-dark text-navy rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
      aria-label="WhatsApp ile İletişim"
    >
      <i className="ri-whatsapp-line text-3xl group-hover:scale-110 transition-transform duration-300"></i>
    </button>
  );
};

export default WhatsAppButton;
